window.localUsabilityClickElements = {
  '#playerbarContantpane a:not([rel*="external"])': {
    //Interner Link in der Playerbar
    'type': 'navigation',
    'click': 'Navigation via Text-Link mit Inhalt "{INNER-TEXT}"',
    'click_chapter1': 'Playerleiste',
    'click_chapter3': '{ZIEL-URL}'
  },
  '#playerbarContantpane a[rel*="external"]': {
    //Externer Link in der Playerbar
    'type': 'exit',
    'click': 'Navigation via Text-Link mit Inhalt "{INNER-TEXT}"',
    'click_chapter1': 'Playerleiste',
    'click_chapter3': '{ZIEL-URL}'
  },
  '#playerbar .audioplayer-control[data-action="play"][aria-pressed="false"]': {
    //Play-Button
    'type': 'action',
    'click': 'Der Play-Button wurde betätigt',
    'click_chapter1': 'Playerleiste',
    'click_chapter3': ''
  },
  '#playerbar .audioplayer-control[data-action="play"][aria-pressed="true"]': {
    //Stopp-Button
    'type': 'action',
    'click': 'Der Stopp-Button wurde betätigt',
    'click_chapter1': 'Playerleiste',
    'click_chapter3': ''
  },
  '#playerbar button[data-target="#playerbarContantpane"][aria-expanded="false"]': {
    //Playerbar aufklappen
    'type': 'action',
    'click': 'Die Playerleiste wurde aufgeklappt',
    'click_chapter1': 'Playerleiste',
    'click_chapter3': ''
  },
  '#playerbar button[data-target="#playerbarContantpane"][aria-expanded="true"]': {
    //Playerbar zuklappen
    'type': 'action',
    'click': 'Die Playerleiste wurde zugeklappt',
    'click_chapter1': 'Playerleiste',
    'click_chapter3': ''
  },
  '#header-main-navi-nav-inner a:not([rel*="external"])': {
    //Interner Link im Menü
    'type': 'navigation',
    'click': 'Navigation via Menüpunkt "{INNER-TEXT}"',
    'click_chapter1': 'Menü',
    'click_chapter3': '{ZIEL-URL}'
  },
  '#header-main-navi-nav-inner a[rel*="external"]': {
    //Externer Link im Menü
    'type': 'exit',
    'click': 'Navigation via Menüpunkt "{INNER-TEXT}"',
    'click_chapter1': 'Menü',
    'click_chapter3': '{ZIEL-URL}'
  },
  '#header .meta-navi a.verkehr': {
    //Meta-Navi Verkehr
    'type': 'navigation',
    'click': 'Navigation via Verkehrs-Button im Header',
    'click_chapter1': 'Menü',
    'click_chapter3': '{ZIEL-URL}'
  },
  '#header .meta-navi a.weather': {
    //Meta-Navi Wetter
    'type': 'navigation',
    'click': 'Navigation via Wetter-Button im Header',
    'click_chapter1': 'Menü',
    'click_chapter3': '{ZIEL-URL}'
  },
  '.more-linking a[rel*="external"]': {
    //Externer Link "Mehr zum Thema"
    'type': 'exit',
    'click': 'Navigation via Text-Link mit Inhalt "{INNER-TEXT}"',
    'click_chapter1': 'Text-Link im Block "Mehr"',
    'click_chapter3': '{ZIEL-URL}'
  },
  '#footer a[rel*="external"]': {
    //Externer Link im Footer
    'type': 'exit',
    'click': 'Navigation via Link im Footer zu "{INNER-TEXT}"',
    'click_chapter1': 'Footer',
    'click_chapter3': '{ZIEL-URL}'
  },
  '.bodytext .event a[rel*="external"]': {
    // Externer Link in Veranstaltungshinweis
    'type': 'exit',
    'click': 'Event-Link zu "{INNER-TEXT}"',
    'click_chapter1': 'Link in Event-Block',
    'click_chapter3': '{ZIEL-URL}'
  },
  '.bodytext .inline-link[rel*="external"]': {
    //Externer Link im Copytext
    'type': 'exit',
    'click': 'Navigation via Text-Link mit Inhalt "{INNER-TEXT}"',
    'click_chapter1': 'Text-Link im Copytext',
    'click_chapter3': '{ZIEL-URL}'
  },
  '.bodytext .linkliste a[rel*="external"]': {
    //Externer Link in Multibox
    'type': 'exit',
    'click': 'Navigation via Text-Link mit Inhalt "{INNER-TEXT}"',
    'click_chapter1': 'Text-Link in Multibox',
    'click_chapter3': '{ZIEL-URL}'
  },
  '.bodytext .bulletpoint-list a': {
    // Navigation in Liveblogs
    'type': 'navigation',
    'click': 'Navigation zu "{INNER-TEXT}"',
    'click_chapter1': 'Text-Link in Bullet-Point-List',
    'click_chapter3': '{ZIEL-URL}'
  },
  'article~.tagleiste-wrapper ul.tagleiste a.tagleiste-element': {
    'type': 'navigation',
    'click': 'Klick auf Button "{INNER-TEXT}"',
    'click_chapter1': 'Schlagwortleiste unter Artikel',
    'click_chapter3': '{ZIEL-URL}'
  },
  '.topic-tags-block .tagleiste-wrapper ul.tagleiste a.tagleiste-element': {
    'type': 'navigation',
    'click': 'Klick auf Button "{INNER-TEXT}"',
    'click_chapter1': 'Schlagwortleiste Übersichtsseite',
    'click_chapter3': '{ZIEL-URL}'
  }
};
